// extracted by mini-css-extract-plugin
export default {"img":"carousel_img__OS4pV","imgH":"carousel_imgH__k6zm+","legend":"carousel_legend__zmJav","imgVert":"carousel_imgVert__hiwZ5","CarouselImg":"carousel_CarouselImg__73EVC"};